import ErrorUtils from "~/utils/error_utils";

export default {
    checkSession() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/login/check-session',
                method: 'GET',
                global: false,
            })
            .done((data) => {
                resolve(data)
            })
            .fail((xhr) => {
                const error = ErrorUtils.createErrorFromXhr(xhr);
                reject(error);
            });
        });
    },

    refreshSession() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/login/refresh',
                method: 'GET',
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                const error = ErrorUtils.createErrorFromXhr(xhr);
                reject(error);
            });
        });
    }
}